// Propiedades
export const WS_URLS = {
  LOGIN: 'sesiones',
  URLOT: 'ot',
  URLETAPAS: 'etapas',
  URLSYNC: 'sync',
  URLCONFAPP: 'confApp',
  URLDOCUMENTOS: 'getDocumentacion',
};

export const STRG_KEYS = {
  APPLICATION: 'e53f97fbad22e0542f5785f81759a186',
  DEVICE: 'clave-dispositivo',
  TOKEN: 'a74a5dc075617838ad664e87ab55a5b7',
  DATA_USER: 'data-user',
  DATA_OT: 'data-ot',
  DATA_ETAPAS: 'data-etapas',
  DATA_APP_CONF: 'data-app-conf',
  DATA_DOCUMENTACION: 'data-app-documentacion',
  DATA_SYNC_OT: 'data-sync-ot',
  LASTSINC: 'data-lastsinc',
  DATA_HSEQ: 'data-hseq',
};


export const MENSAJES_SISTEMA = {
  NO_CONEXION: 'No se pudo establecer la conexión con el servidor',
  CREDENCIALES_INCORRECTAS: 'Usuario y/o contraseña incorrectos',
  NOSESION: 'No se pudo iniciar sesion',
  MSJ_GENERICO: 'Error al obtener los datos'
};
